module.exports = __webpack_public_path__ + "static/media/bg_top.d0fde7c0.svg";